<template>
  <div class="other-information mt-5 lg:mt-10">
    <the-section :title="$t('ec-line004.otherInformation.title')">
      <el-form ref="other-form" class="other-information__form" label-position="top">
        <el-form-item :label="$t('ec-line004.otherInformation.mediaDistinction')">
          <disabled-input :value="whereFindProduct" />
        </el-form-item>
        <el-form-item :label="$t('ec-line029.content.remarks')">
          <disabled-input :value="data.advertisement_remarks" />
        </el-form-item>
      </el-form>
    </the-section>
  </div>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import DisabledInput from '@/components/DisabledInput.vue'

export default {
  components: { TheSection, DisabledInput },
  props: {
    data: { type: Object, default: () => {} },
  },
  computed: {
    whereFindProduct() {
      if (this.data.where_find_product) {
        return this.$store.state.master.whereDidYouKnow?.find((item) => item.id === this.data.where_find_product)?.name
      } else {
        return ''
      }
    },
  },
}
</script>
